import { render, staticRenderFns } from "./UnluckConfigDialog.vue?vue&type=template&id=98bfef2c&scoped=true&"
import script from "./UnluckConfigDialog.vue?vue&type=script&lang=js&"
export * from "./UnluckConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bfef2c",
  null
  
)

export default component.exports